import { useEffect } from 'react';

import { forterScript } from '@/utils/forter-script';

const ForterComponent = () => {
  useEffect(() => {
    // Forter JavaScript snippet
    const siteId = `${process.env.NEXT_PUBLIC_FORTER_SITE_ID}`;
    forterScript(siteId);
  }, []);

  return null;
};

export default ForterComponent;
